import { useTranslation } from "react-i18next";

import { BillingIntervalOption } from "src/components/BillingIntervalOption";

interface Props {
  value: "MONTH" | "YEAR";
  onChange: (value: "MONTH" | "YEAR") => void;
}

export function BillingIntervalToggle(props: Props) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white p-1">
      <BillingIntervalOption
        active={props.value === "MONTH"}
        onClick={() => {
          props.onChange("MONTH");
        }}
      >
        {t("pricing.monthly")}
      </BillingIntervalOption>
      <BillingIntervalOption
        active={props.value === "YEAR"}
        onClick={() => {
          props.onChange("YEAR");
        }}
      >
        {t("pricing.yearly")}
        <span className="ml-2 font-semibold text-emerald-600">
          {t("pricing.yearlyDiscount")}
        </span>
      </BillingIntervalOption>
    </div>
  );
}
